export const apiconfig = {
    getAPIPath,
    getAPIUri
};

function getAPIPath() {
    return 'http://www.navigatehive.com:8000';
}

function getAPIUri() {
    return 'https://hapi.navigatehive.com';
}